import { mediaQueryUp } from 'components/utils/breakpoint'
import { css } from 'styled-components'
import config from 'constants/config'
import { generateCSSVarEntries, getThemeClassName } from 'lib/theme/themeUtils'

const DefaultStyle = css(Object.fromEntries(generateCSSVarEntries(config.theme.defaultPalette, 'palette')))
const InverseStyle = css(Object.fromEntries(generateCSSVarEntries(config.theme.inversePalette, 'palette')))
const BorderRadiiStyle = css(Object.fromEntries(generateCSSVarEntries(config.theme.borderRadius, 'border-radius')))
const ShadowsStyle = css(Object.fromEntries(generateCSSVarEntries(config.theme.shadows, 'shadow')))

const ThemeStyles = css`
  :root {
    ${BorderRadiiStyle}
    ${ShadowsStyle}
  }
  :root,
  .${getThemeClassName({ mobile: 'default' })} {
    ${DefaultStyle}
    color: ${props => props.theme.palette.neutral.default.one};
  }
  .${getThemeClassName({ mobile: 'inverse' })} {
    ${InverseStyle}
    color: ${props => props.theme.palette.neutral.default.one};
  }
  ${mediaQueryUp.tablet} {
    .${getThemeClassName({ tablet: 'default' })} {
      ${DefaultStyle}
      color: ${props => props.theme.palette.neutral.default.one};
    }
    .${getThemeClassName({ tablet: 'inverse' })} {
      ${InverseStyle}
      color: ${props => props.theme.palette.neutral.default.one};
    }
  }
  ${mediaQueryUp.desktop} {
    .${getThemeClassName({ desktop: 'default' })} {
      ${DefaultStyle}
      color: ${props => props.theme.palette.neutral.default.one};
    }
    .${getThemeClassName({ desktop: 'inverse' })} {
      ${InverseStyle}
      color: ${props => props.theme.palette.neutral.default.one};
    }
  }
  ${mediaQueryUp.largeDesktop} {
    .${getThemeClassName({ largeDesktop: 'default' })} {
      ${DefaultStyle}
      color: ${props => props.theme.palette.neutral.default.one};
    }
    .${getThemeClassName({ largeDesktop: 'inverse' })} {
      ${InverseStyle}
      color: ${props => props.theme.palette.neutral.default.one};
    }
  }
  ${mediaQueryUp.extraLargeDesktop} {
    .${getThemeClassName({ extraLargeDesktop: 'default' })} {
      ${DefaultStyle}
      color: ${props => props.theme.palette.neutral.default.one};
    }
    .${getThemeClassName({ extraLargeDesktop: 'inverse' })} {
      ${InverseStyle}
      color: ${props => props.theme.palette.neutral.default.one};
    }
  }
`

export default ThemeStyles
